import { type ReactNode, Suspense } from 'react';
import { StreamPageHeaderV2 } from './stream-page-header-v2.tsx';
import { streamPageV2 } from './stream-page-v2.css.ts';

export const StreamPageV2 = ({ children }: { children: ReactNode }) => (
  <div className={streamPageV2}>
    <Suspense fallback={null}>
      <StreamPageHeaderV2 />
    </Suspense>
    {children}
  </div>
);
